<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="breadcrumb-area rn-bg-color ptb--120 bg_image bg_image--35"
      data-black-overlay="6"
    >
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="breadcrumb-inner pt--100">
              <h2 class="heading-title">Service</h2>
              <ul class="page-list">
                <li
                  class="rn-breadcrumb-item"
                  v-for="(item, i) in breadcrumbs"
                  :key="i"
                >
                  <router-link :to="item.to" :disabled="item.disabled">{{
                    item.text
                  }}</router-link>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Service Area  -->
    <div class="service-area ptb--120 bg_color--1">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title mb--30">
              <span class="subtitle">Our Expertise</span>
              <h2>Technical Excellence</h2>
              <p>
                With years of experience in software development and IT services,
                <br />
                we deliver solutions that drive business success.
              </p>
            </div>
          </v-col>
        </v-row>
        <!-- End .row -->
        <v-row class="service-main-wrapper">
          <!-- Start Single Service  -->
          <v-col
            lg="4"
            md="4"
            sm="6"
            cols="12"
            v-for="(service, i) in serviceContent"
            :key="i"
          >
            <div class="text-center service service__style--2">
              <div class="service">
                <div class="icon" v-html="iconSvg(service.icon)"></div>
                <div class="content">
                  <h3 class="heading-title">{{ service.title }}</h3>
                  <p>
                    {{ service.desc }}
                  </p>
                </div>
              </div>
            </div>
          </v-col>
          <!-- End Single Service  -->
        </v-row>
      </v-container>
    </div>
    <!-- End Service Area  -->

    <Footer />
  </div>
</template>

<script>
  import Header from "../../components/header/Header";
  import ServiceThree from "../../components/service/ServiceThree";
  import ServiceFour from "../../components/service/ServiceFour";
  import ServiceTwo from "../../components/service/ServiceTwo";
  import Footer from "../../components/footer/Footer";
  import feather from "feather-icons";
  export default {
    components: {
      Header,
      ServiceThree,
      ServiceFour,
      ServiceTwo,
      Footer,
    },
    data() {
      return {
        logo: require("../../assets/images/logo/logo-ko.png"),
        breadcrumbs: [
          {
            text: "Home",
            to: "/",
            disabled: false,
          },
          {
            text: "Service",
            to: "",
            disabled: true,
          },
        ],
        serviceContent: [
          {
            icon: "code",
            title: "Backend Development",
            desc: "We specialize in building robust, scalable backend systems using Laravel/PHP, Node.js, and Python. Our expertise includes RESTful API development, microservices architecture, and cloud integration to ensure your applications are secure, efficient, and maintainable.",
          },
          {
            icon: "monitor",
            title: "Frontend Development",
            desc: "Create stunning, responsive web applications with our expert frontend development team. We leverage Vue.js, React.js, and Quasar framework to build intuitive user interfaces that deliver exceptional user experiences across all devices and platforms.",
          },
          {
            icon: "database",
            title: "Database Management",
            desc: "Optimize your data infrastructure with our comprehensive database solutions. We implement and manage MySQL, PostgreSQL, and MongoDB databases, ensuring optimal performance, security, and scalability for your business applications.",
          },
          {
            icon: "smartphone",
            title: "Mobile Development",
            desc: "Transform your business with cross-platform mobile applications. Using Flutter, Ionic, and Framework7, we develop feature-rich mobile apps that provide seamless experiences across iOS and Android platforms while maintaining native-like performance.",
          },
          {
            icon: "server",
            title: "Server Management",
            desc: "Ensure your applications run smoothly with our professional server management services. We handle server setup, maintenance, security, and optimization, providing 24/7 monitoring and support to keep your systems running at peak performance.",
          },
          {
            icon: "trending-up",
            title: "Digital Marketing",
            desc: "Grow your online presence with our strategic digital marketing solutions. We combine SEO, content marketing, social media management, and analytics to help you reach your target audience, increase engagement, and drive business growth.",
          },
        ],
      };
    },

    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>

<style lang="scss">
  .service-white-wrapper
    .service-main-wrapper
    .service.service__style--2.bg-gray {
    background: #fff;
  }
</style>
